import {
  Download1Stroke,
  PrinterStroke,
  RefreshCircle1ClockwiseStroke,
  Search1Stroke,
  SignPostLeftStroke
} from '@lineiconshq/free-icons';
import { AritoActionBar, AritoActionButton, AritoIcon, AritoMenuButton } from '@/components/custom/erp';
import type { SoQuyTienMatSearchFormValues } from '@/types/schemas';
import { useSoQuyTienMatContext } from '../context';
import { formatDate } from '@/lib/formatUtils';

interface ActionBarProps {
  onSearchClick?: () => void;
  onRefreshClick?: () => void;
  onPrintClick?: () => void;
  onFixedColumnsClick?: () => void;
  onEditPrintTemplateClick?: () => void;
  className?: string;
  searchParams?: SoQuyTienMatSearchFormValues;
}

const ActionBar: React.FC<ActionBarProps> = ({
  onSearchClick,
  onRefreshClick,
  onPrintClick,
  onFixedColumnsClick,
  onEditPrintTemplateClick,
  className,
  searchParams
}) => {
  const { exportToExcel, canExport, isExporting } = useSoQuyTienMatContext();

  return (
    <AritoActionBar
      className={className}
      titleComponent={
        <div>
          <h1 className='text-xl font-bold'>Sổ quỹ tiền mặt</h1>
          {searchParams && (
            <div className='text-[10px] text-gray-500'>
              <p className='font-semibold'>
                <span className='mr-2 inline-block h-2 w-2 rounded-full bg-red-600'></span>
                <span>
                  Tài khoản:{' '}
                  {searchParams?.tk?.code || searchParams?.tk?.name
                    ? [searchParams.tk.code, searchParams.tk.name].filter(Boolean).join(' - ')
                    : ''}
                </span>
                <span>, từ ngày </span>
                <span>{formatDate(searchParams?.ngay_ct1)}</span>
                <span> đến ngày </span>
                <span>{formatDate(searchParams?.ngay_ct2)}</span>
              </p>
            </div>
          )}
        </div>
      }
    >
      {onSearchClick && (
        <AritoActionButton title='Tìm kiếm' icon={Search1Stroke} onClick={onSearchClick} variant='secondary' />
      )}
      <AritoActionButton title='In ấn' icon={PrinterStroke} onClick={onPrintClick} />
      {onRefreshClick && (
        <AritoActionButton
          title='Refresh'
          icon={RefreshCircle1ClockwiseStroke}
          onClick={onRefreshClick}
          variant='secondary'
        />
      )}
      {onFixedColumnsClick && (
        <AritoActionButton
          title='Cố định cột'
          icon={SignPostLeftStroke}
          onClick={onFixedColumnsClick}
          variant='secondary'
        />
      )}
      <AritoActionButton
        title='Kết xuất dữ liệu'
        icon={Download1Stroke}
        onClick={exportToExcel}
        variant='secondary'
        disabled={!canExport || isExporting}
        loading={isExporting}
        loadingTitle='Đang kết xuất...'
      />
      <AritoMenuButton
        items={[
          {
            title: 'Chỉnh sửa mẫu in',
            icon: <AritoIcon icon={864} />,
            onClick: onEditPrintTemplateClick,
            group: 0
          }
        ]}
      />
    </AritoActionBar>
  );
};

export default ActionBar;
